import { useEffect, useState } from "react"
import { useMediaPredicate } from "react-media-hook"
import { usePropsObject } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import CTA from "@/common/article/cta"

export default function ArticleCTA({ block }) {
  const object = usePropsObject()
  const isMobile = useMediaPredicate("(max-width: 640px)")
  const [hasMounted, setMounted] = useState(false)

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setMounted(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isMobile || !hasMounted) {
    return null
  }

  return (
    <Block block={block} width="bleed">
      <CTA data={object?.cta} inserted={true} />
    </Block>
  )
}
